import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/graphql/base-query";

const GET_HTS_DESCRIPTIONS = `
  query GetHTSDescriptions($input: HTSDescriptionInput!) {
    getHTSDescriptions(input: $input) {
      htsCode
      description
    }
  }
`;

export interface HTSDescription {
  htsCode: string;
  description?: string | null;
}

export interface HTSDescriptionInput {
  htsCodes: string[];
}

export interface GetHTSDescriptionsResponse {
  getHTSDescriptions: HTSDescription[];
}

export const htsDescriptionsApi = createApi({
  reducerPath: "htsDescriptionsApi",
  baseQuery,
  endpoints: (builder) => ({
    getHTSDescriptions: builder.query<GetHTSDescriptionsResponse, HTSDescriptionInput>({
      query: (input) => ({
        document: GET_HTS_DESCRIPTIONS,
        variables: { input },
      }),
    }),
  }),
});

export const { useGetHTSDescriptionsQuery, useLazyGetHTSDescriptionsQuery } = htsDescriptionsApi;